import React from 'react';
import { PaginationRow } from 'vetrf-ui';
import { DefaultFindFnParams, PaginationResponse } from '../../types/api';
import { DEFAULT_ITEM_PER_PAGE, DEFAULT_PAGE_NUMBER, PER_PAGE_ARRAY } from './consts';
import styles from './RegistryPagination.module.scss';

type RegistryPaginationProps<T> = {
  handlePaginationChange: (item: Partial<DefaultFindFnParams>) => void;
  tableData: PaginationResponse<T>;
};

export const RegistryPagination = <T,>({
  tableData,
  handlePaginationChange,
}: RegistryPaginationProps<T>) => {
  const handlePageChange = (value: number) => {
    const formattedValue = {
      pageDetails: {
        itemsPerPage: tableData?.itemPerPage || DEFAULT_ITEM_PER_PAGE,
        pageNumber: value,
      },
    };
    handlePaginationChange(formattedValue);
  };

  const handlePageSizeChange = (value: number) => {
    const formattedValue = {
      pageDetails: {
        itemsPerPage: value,
        pageNumber: DEFAULT_PAGE_NUMBER,
      },
    };
    handlePaginationChange(formattedValue);
  };
  return (
    <div className={styles.paginationBlock}>
      <PaginationRow
        page={tableData.pageNumber}
        sizePerPage={tableData.itemPerPage}
        itemCount={tableData.itemCount}
        onChangeSizePerPage={handlePageSizeChange}
        onChangePage={handlePageChange}
        options={PER_PAGE_ARRAY}
      />
    </div>
  );
};
